export default function Testimonial() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-foreground-950 rounded-[40px] p-8 md:p-14 overflow-hidden">
          <div className="absolute top-8 left-8 text-8xl md:text-9xl font-heading text-background-50/8 leading-none select-none">
            &ldquo;
          </div>

          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center relative z-10">
            <div className="w-full md:w-2/5 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20business%20professional%20leaning%20against%20modern%20office%20window%20with%20city%20skyline%20softly%20blurred%20in%20background%2C%20warm%20golden%20hour%20side%20lighting%20creating%20dramatic%20yet%20approachable%20portrait%2C%20genuine%20relaxed%20expression%2C%20contemporary%20casual%20blazer%20outfit%2C%20editorial%20corporate%20portrait%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20sophisticated%20urban%20professional%20atmosphere&width=600&height=800&seq=yoybuy-testimonial-v2&orientation=portrait"
                alt="Отзыв клиента"
                className="w-full h-auto rounded-2xl object-cover"
                loading="lazy"
              />
            </div>

            <div className="flex-1">
              <p className="text-lg md:text-xl text-background-50 leading-relaxed mb-6">
                YOYBUY Spreadsheet полностью изменил мой подход к закупкам из Китая. Я экономлю минимум 30% на каждом заказе и всегда знаю актуальные цены. Система таблиц позволяет быстро сравнивать товары и находить лучшие предложения.
              </p>
              <div>
                <p className="text-base font-semibold text-background-50">
                  Алексей М.
                </p>
                <p className="text-sm text-background-50/50 mt-1">
                  Предприниматель, Москва
                </p>
              </div>

              <div className="mt-8">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
                >
                  <span>Начать с YOYBUY Spreadsheet</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}